import { ConversationsChannels } from 'lib-shared-legacy-types';

const reviewChannels: ReadonlySet<ConversationsChannels> = new Set([
  'trustpilotreviews',
  'yotporeviews',
]);

export const isReviewChannel = (
  channel?: ConversationsChannels | null,
): boolean => !!channel && reviewChannels.has(channel);
